<template>
  <button
    class="k-button"
    :disabled="disabled"
    :class="classes"
  >
    <k-icon
      v-if="!noIcon && !loading"
      :icon="iconAdjusted"
      class="icon"
      :style="iconStyles"
    />
    <div
      class="loading"
      v-if="loading"
    >
      <loading
        size="sm"
        color="white"
      />
    </div>
    <slot />
  </button>
</template>

<script>
import KIcon from './KIcon.vue';
import Loading from '../icons/Loading.vue'

export default {
  name: "KButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'md'
    },
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: 'arrow-right'
    },
    iconSize: {
      type: [String, Number],
      default: null
    },
    noIcon: {
      type: Boolean,
      default: false
    },
  },
  components: {
    KIcon,
    Loading
  },
  computed: {
    classes () {
      let defaultClasses = ''
      if (this.disabled) defaultClasses += ' -disabled'
      if (this.type !== 'default') defaultClasses += ` -type-${this.type}`
      if (this.color !== 'primary') defaultClasses += ` -${this.color}`
      if (this.size !== 'md') defaultClasses += ` -${this.size}`

      return defaultClasses
    },
    iconAdjusted () {
      if (this.icon !== 'arrow-right') return this.icon
      if (this.type === 'send') return 'arrow-right'

      return 'arrow-right'
    },
    iconStyles() {
      if (this.iconSize) return `font-size: ${this.iconSize}px`
      return null
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/main.scss";

.k-button {
  background: $neutral-1;
  color: $neutral-2;
  border: none;
  width: 254px;
  height: 56px;
  padding: 0 22px;
  border-radius: 8px;
  cursor: pointer;
  transition: all ease 0.2s;
  text-transform: uppercase;
  @include heading-5;
  position: relative;

  @include media-query(mobile) {
    width: 100%;
  }
  .loading {
    width: 20px;
    height: 20px;
  }

  .icon,
  .loading {
    position: absolute;
    left: 15px;
    right: auto;
    bottom: 20px;
  }

  &:hover {
    background: lighten($neutral-1, 20%);
  }
  &:disabled {
    background: $disabled-color;
    cursor: not-allowed;
  }

  &.-primary-6 {
    background: $primary-6;
    &:hover {
      background: lighten($primary-6, 20%);
    }
  }

  &.-type-send {
    .icon {
      font-size: 24px;
      right: 15px;
      left: auto;
      bottom: 16px;
    }
    .loading {
      right: 15px;
      left: auto;
      bottom: 22px;
    }
    .loading {
      bottom: 19px;
    }
    &.-sm {
      .icon {
      font-size: 14px;
      right: 15px;
      left: auto;
      bottom: 16px;
    }
    }
  }

  &.-type-small {
    height: 40px;
    .icon,
    .loading {
      bottom: 14px;
    }
    .loading {
      bottom: 10px;
    }
  }
  &.-sm {
    height: 40px;
    .icon,
    .loading {
      bottom: 14px;
    }
    .loading {
      bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/kaledo-components/src/components/KButton.vue